document.addEventListener('DOMContentLoaded', function() {
  const menuItems = document.querySelectorAll('.header__menu-item');
  const submenuItems = document.querySelectorAll('.header__menu-subitems');
  
  menuItems.forEach(item => {
    item.addEventListener('keydown', function(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        toggleSubmenu(item);
        event.preventDefault();
      }
    });
  });

  function toggleSubmenu(item) {
    const submenu = item.nextElementSibling;
    const isExpanded = item.parentElement.getAttribute('aria-expanded') === 'true';

    if (submenu && submenu.classList.contains('header__menu-subitems')) {
      if (isExpanded) {
        closeSubmenu(item);
      } else {
        openSubmenu(item);
      }
    }
  }

  function openSubmenu(item) {
    closeAllSubmenus();
    const submenu = item.nextElementSibling;
    item.parentElement.setAttribute('aria-expanded', 'true');
    submenu.classList.add('active');
    submenu.querySelector('a').focus();
    $("body").addClass("active");
    $("body").addClass("desk-menu-opened");
    $('.menu-backdrop').fadeIn();
  }

  function closeSubmenu(item) {
    const submenu = item.nextElementSibling;
    item.parentElement.setAttribute('aria-expanded', 'false');
    submenu.classList.remove('active');
    item.focus();  // Return focus to the main menu item
    $("body").removeClass("active");
    $("body").removeClass("desk-menu-opened");
    $('.menu-backdrop').fadeOut();
  }

  function closeAllSubmenus() {
    submenuItems.forEach(submenu => {
      submenu.parentElement.setAttribute('aria-expanded', 'false');
      submenu.classList.remove('active');
    });
  }

  submenuItems.forEach(submenu => {
    const submenuLinks = submenu.querySelectorAll('a');

    submenuLinks.forEach((link, index) => {
      link.addEventListener('keydown', function(event) {
        if (event.key === 'ArrowDown') {
          // Go to the next submenu item
          const nextItem = submenuLinks[index + 1] || submenuLinks[0];
          nextItem.focus();
          event.preventDefault();
        } else if (event.key === 'ArrowUp') {
          // Go to the previous submenu item
          const prevItem = submenuLinks[index - 1] || submenuLinks[submenuLinks.length - 1];
          prevItem.focus();
          event.preventDefault();
        } else if (event.key === 'Escape') {
          // Close the submenu and return focus to the original main menu item
          const parentItem = submenu.parentElement.querySelector('.header__menu-item');
          closeSubmenu(parentItem);
          event.preventDefault();
        }
      });
    });
  });
});




  function toggleTabIndex() {
    if ($('.cart-drawer').hasClass('active')) {
      // Add tabindex="0" when the cart drawer is opened
      $('.cart-drawer__minus, .cart-drawer__plus, .cart-drawer__title span, .cart-drawer__top-right, .cart-drawer__upsell-btn')
        .attr('tabindex', '0');
      $('.cart-drawer__top-right').focus();
    } else {
      // Remove tabindex when the cart drawer is closed
      $('.cart-drawer__minus, .cart-drawer__plus, .cart-drawer__title span, .cart-drawer__top-right, .cart-drawer__upsell-btn')
        .removeAttr('tabindex');
    }
  }

  // Initially check the status of the cart drawer
  toggleTabIndex();

  // Monitor for changes when the cart drawer is toggled (e.g., the 'active' class is added or removed from the body)
  $(document).on('classChange', function() {
    toggleTabIndex();
  });

  // Simulate detection of class changes on the body (cart drawer open/close)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.attributeName === 'class') {
        $(document).trigger('classChange');  // Trigger class change event
      }
    });
  });

  // Observe changes to the body's class attribute
  observer.observe(document.body, { attributes: true });








$(document).on('keydown', '.cart-drawer__minus', function(event) {
  if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault(); // Prevent default space behavior
      $(this).click(); // Trigger the click event
    }
});

$(document).on('keydown', '.cart-drawer__plus', function(event) {
  if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      $(this).click();
    }
});

$(document).on('keydown', '.cart-drawer__title span', function(event) {
  if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      $(this).click();
    }
});

$(document).on('keydown', '.cart-drawer__top-right', function(event) {
  if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      $(this).click();
      $('.header__cart').focus();
    }
});
$(document).on('keydown', '.collection-item__plan', function(event) {
  if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      $(this).click();
    }
});

$('.single-product__subscribe-item-onetime').click(function(){
  $('.single-product__subscribe-select').attr('name', '');
});
$('.single-product__subscribe-item-subscribe').click(function(){
  $('.single-product__subscribe-select').attr('name', 'selling_plan');
})

$('.collection-item__oneTime-plan').click(function(){
  $('.collection-item__subscribe-plan-select').attr('name', '');
  def_price = "one-time";
});
$('.collection-item__subscribe-plan').click(function(){
  $('.collection-item__subscribe-plan-select').attr('name', 'selling_plan');
  def_price = "subs";
})
